import { render, staticRenderFns } from "./NtakDashboardContentComponent.vue?vue&type=template&id=06354956&scoped=true&"
import script from "./NtakDashboardContentComponent.vue?vue&type=script&lang=js&"
export * from "./NtakDashboardContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./NtakDashboardContentComponent.vue?vue&type=style&index=0&id=06354956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06354956",
  null
  
)

export default component.exports